export const formatMass = (
    value: string | number | undefined | null,
    { fractionDigits = 6, unit = 'kg' }: { fractionDigits?: number; unit?: string } = {}
): string | undefined => {
    if (value === undefined || value === null || value === '') return undefined;
    const parsed = parseFloat(String(value));
    if (Number.isNaN(parsed)) return undefined;
    return `${parsed.toFixed(fractionDigits)}${unit ? ` ${unit}` : ''}`;
};
